<template>
    <b-modal
        :id="modalId"
        class="modal-demo"
        title-class="text-light"
        header-bg-variant="dark"
        header-text-variant="light"
        title-tag="h4"
        size="lg"
        :title="title"
        centered
        @hide="hideModal"
    >
        <div class="row">
            <div class="col-12 form-group">
                <label for="subject">Subject</label>
                <input
                    id="subject"
                    v-model="formData.subject"
                    class="form-control"
                    :class="{ 'is-invalid': hasError('subject') }"
                    type="text"
                    dir="auto"
                />
                <div class="invalid-feedback">
                    {{ getError('subject') }}
                </div>
            </div>
            <div class="col-12 form-group">
                <label for="message">Message</label>
                <textarea
                    id="message"
                    v-model="formData.message"
                    class="form-control rtl"
                    :class="{ 'is-invalid': hasError('message') }"
                    rows="5"
                    dir="auto"
                />
                <div class="invalid-feedback">
                    {{ getError('message') }}
                </div>
            </div>
        </div>
        <template #modal-footer>
            <div class="col-12 d-flex justify-content-between">
                <button
                    type="submit"
                    class="btn btn-danger waves-effect waves-light"
                    @click="hideModal"
                >
                    Close
                </button>
                <button
                    type="submit"
                    class="btn btn-success waves-effect waves-light"
                    @click="send"
                >
                    Send
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { StatusCodes as HTTP } from 'http-status-codes';

export default {
    validations: {
        formData: {
            subject: {
                required
            },
            message: {
                required
            }
        }
    },

    props: {
        modalId: {
            type: String,
            required: false,
            default: 'send-email-to-user-modal'
        },
        user: {
            type: Object,
            required: true
        }
    },

    data() {
        const defaultForm = { subject: '', message: '' };

        return {
            defaultForm,
            formData: { ...defaultForm },
            serverErrors: []
        };
    },

    computed: {
        title() {
            return `Send E-mail to ${this.user.fullName} (${this.user.email})`;
        }
    },

    methods: {
        ...mapActions({
            sendEmail: 'users/sendEmail'
        }),

        hideModal() {
            this.$bvModal.hide(this.modalId);

            this.$v.$reset();
        },

        async send() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                await this.sendEmail({ ...this.formData, id: this.user.id });

                this.$v.$reset();
                this.formData = { ...this.defaultForm };

                this.$toaster('Email sent!');
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        },

        hasError(key) {
            return (
                this.$v.formData[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.$v.formData,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
